<div class="icloud-relay-banner" role="alert">
  <div class="icloud-relay-banner__header">
    <div class="icloud-relay-banner__icon-wrap" aria-hidden="true">
      <mat-icon>shield</mat-icon>
    </div>
    <div class="icloud-relay-banner__headings">
      <p class="icloud-relay-banner__eyebrow">iCloud Private Relay</p>
      <h2 class="icloud-relay-banner__title">No podemos detectar la oficina</h2>
    </div>
  </div>

  <p class="icloud-relay-banner__text">
    Safari está ocultando tu IP real. En este sitio, usa
    <strong>Mostrar dirección IP</strong>.
  </p>

  <details class="icloud-relay-banner__details">
    <summary class="icloud-relay-banner__toggle icloud-relay-banner__toggle--ghost">
      <mat-icon class="icloud-relay-banner__summary-icon icloud-relay-banner__summary-icon--closed" aria-hidden="true"
        >help_outline</mat-icon
      >
      <mat-icon class="icloud-relay-banner__summary-icon icloud-relay-banner__summary-icon--open" aria-hidden="true">expand_less</mat-icon>
      <span class="icloud-relay-banner__summary-label icloud-relay-banner__summary-label--closed">¿Cómo lo hago?</span>
      <span class="icloud-relay-banner__summary-label icloud-relay-banner__summary-label--open">Ocultar</span>
    </summary>

    <div class="icloud-relay-banner__tutorial">
      <img
        class="icloud-relay-banner__gif"
        src="assets/img/tutorial-mostrar-direccion-ip.gif"
        alt="Tutorial: en Safari, Mostrar dirección IP para este sitio"
        loading="lazy"
        decoding="async"
      />
    </div>
  </details>
</div>
